<template>
  <div>
    <inner-app></inner-app>
  </div>
</template>

<script>
  import store from './vuex/store';
  import InnerApp from './innerApp';

  export default {
    store,
    components: {
      InnerApp
    }
  }
</script>
